import axios from "axios";
//export const BASE_URL = "http://localhost:8080/felahlink/";
export const BASE_URL = "/felahlink/";

export const myAxios = axios.create({
    baseURL: BASE_URL,
    timeout: 30000
});
// Intercepteur des requêtes
myAxios.interceptors.request.use(
    (config) => {

        return config;
    },
    (error) => {
        console.log("ERREUR INTERCEPTEUR REQUETE");
        console.log(error);
        return Promise.reject(error);
    }
);

// Intercepteur des réponses
myAxios.interceptors.response.use(
    (response) => {

        return response;
    },
    (error) => {
        console.log("ERREUR AXIOS");
        if (error.response) {
            console.log("STATUS :", error.response.status);
        } else if (error.request) {
            console.log("AUCUNE REPONSE DU SERVEUR");
            console.log(error.request);
        } else {
            console.log("MESSAGE :", error.message);
        }

        console.log("======================================");
        return Promise.reject(error);
    }
);

